// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fog-sunny"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12H2M16.584 14C16.8516 13.3875 17 12.7111 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 12.7111 7.14845 13.3875 7.41604 14M5.63679 5.63484L4.92969 4.92773M12 2V3M19.0704 4.92773L18.3633 5.63484M22 12H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 18H7M11 18H21M3 22H14M18 22H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FogSunnyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fog-sunny',
    ref,
    icon: element,
  },
));

FogSunnyIcon.displayName = 'FogSunnyIcon';

export default FogSunnyIcon;
